import { render, staticRenderFns } from "./AsyncFallback.vue?vue&type=template&id=113b14d9&scoped=true&"
import script from "./AsyncFallback.vue?vue&type=script&lang=js&"
export * from "./AsyncFallback.vue?vue&type=script&lang=js&"
import style0 from "./AsyncFallback.vue?vue&type=style&index=0&id=113b14d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b14d9",
  null
  
)

export default component.exports